import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { colors, fonts, spacing, borderRadius } from "../../../constants";

/**
 * FormFooter Component
 * Footer with Cancel and Raise Query buttons
 *
 * @param {boolean} loading - Whether form is submitting
 * @param {Function} onCancel - Cancel handler
 * @param {Function} onSubmit - Submit handler
 */
const FormFooter = ({
  loading,
  onCancel,
  onSubmit,
  submitLabel = "Raise Query",
  showSubmit = true
}) => (
  <Box
    sx={{
      padding: `${spacing.sm} ${spacing.md}`,
      borderTop: `1px solid #e5e7eb`,
      background:
        "linear-gradient(135deg, rgba(14, 23, 42, 0.05) 0%, rgba(250, 204, 21, 0.08) 100%)",
      gap: spacing.xs,
      display: "flex",
      justifyContent: "flex-end",
      flexShrink: 0
    }}
  >
    <Button
      onClick={onCancel}
      variant="outlined"
      sx={{
        textTransform: "none",
        borderRadius: borderRadius.button,
        padding: `${spacing.xs} ${spacing.md}`,
        fontSize: fonts.fontSizeMd,
        fontWeight: fonts.weightSemiBold,
        color: colors.primaryDark,
        border: `1px solid ${colors.borderDefault}`,
        backgroundColor: colors.backgroundWhite,
        "&:hover": {
          backgroundColor: colors.backgroundWhite,
          borderColor: colors.primaryDark,
          color: colors.primaryDark
        }
      }}
    >
      Cancel
    </Button>
    {/* {showSubmit && ( */}
    <Button
      onClick={onSubmit}
      variant="contained"
      sx={{
        textTransform: "none",
        borderRadius: borderRadius.button,
        padding: `${spacing.xs} ${spacing.md}`,
        fontSize: fonts.fontSizeMd,
        fontWeight: fonts.weightSemiBold,
        background: colors.primaryGradient,
        color: colors.textWhite,
        boxShadow: `0 4px 12px ${colors.primaryShadow}`,
        "&:hover": {
          background: colors.primaryGradientHover,
          boxShadow: `0 6px 16px ${colors.primaryShadowHover}`
        }
      }}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ color: colors.textWhite }} />
      ) : (
        submitLabel
      )}
    </Button>
    {/* )} */}
  </Box>
);

export default FormFooter;
